import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add FinancialYear Service */
const addFinancialYear = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.createFinancialYear}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get FinancialYear Service */
const getAllFinancialYear = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getAllFinancialYears}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };




  /* Update Financial Year Service */
  const updateFinancialYear = (params) => {
    const { axiosInstance,config } = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.updateFinancialYear}`,
      method: "PUT",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


   /* Get Financial Year Service */
   const getFinancialYearList = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getFinancialYearList}`,
      method: "GET",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

     /* Get Financial Year Service */
     const getFinancialYearWiseMonth = (params) => {
      const { axiosInstance ,config} = getAxiosConfig();
      const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getFinancialYearWiseMonth}`,
        method: "GET",
        params: params,
        headers: config.headers ||null,
        mode: "no-cors",
      })
        .then((res) => {
          return setFormatedResponse(res);
        })
        .catch((error) => {
          return getFomatedError(error);
        });
      return response;
    };
  

export default {
    addFinancialYear,
    getAllFinancialYear,
    updateFinancialYear,
    getFinancialYearList,
    getFinancialYearWiseMonth

}